import React from 'react';
import { camelCase } from 'lodash';
import {
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';
import { SingleAttachmentInputFormField } from '../../../../../../../../components/SingleAttachmentInputFormField';
import { SurveyQuestion } from '../../../../../../../../entities/survey_engine/SurveyQuestion';
import { SubmitApplicationFormDto } from '../../..';

interface PropTypes {
  question: SurveyQuestion;
  formRegister: UseFormRegister<any>;
  getValues?: UseFormGetValues<any>;
  setValue?: UseFormSetValue<any>;
  disabled?: boolean;
}

export function AttachmentQuestionInput(props: PropTypes) {
  const disabled = props.disabled ?? false;

  return (
    <SingleAttachmentInputFormField<SubmitApplicationFormDto>
      className='p-0'
      getValues={props.getValues}
      setValue={props.setValue}
      formRegister={props.formRegister}
      controllerFileName={`${camelCase(props.question.tag)}.filename`}
      controllerContentName={`${camelCase(props.question.tag)}.content`}
      fieldName={''}
      allowedFormats={['.pdf', '.doc', '.docx']}
      maxFileSizeMb={10}
      isRequired={props.question.mandatory}
      hideHeader={true}
      disabled={disabled}
    />
  );
}
